type GrowthPercentOrValue = { difference: number; isPercent: false } | { growth: number; isPercent: true };

/**
 * Calculates the growth of a value in percent.
 * If the previous value is 0, returns the difference as a percent from 1
 * E.g:
 * `growthPercentage(1, 2) = 1`
 * `growthPercentage(1, 1.5) = 0.5`
 * `growthPercentage(9, 13) = 0.4444...`
 *
 * @param previousValue - The previous number
 * @param currentValue - The current number
 * @returns - The growth percentage or the difference as number in an object
 */
export function growthPercentage(previousValue: number, currentValue: number): GrowthPercentOrValue {
    if (previousValue === 0) {
        return {
            difference: currentValue,
            isPercent: false,
        };
    } else {
        const difference = currentValue - previousValue;
        if (difference !== 0) {
            return {
                growth: difference / previousValue,
                isPercent: true,
            };
        } else {
            return {
                growth: 0,
                isPercent: true,
            };
        }
    }
}
